const old = `<!--begin::FAQ card-->
<div class="card card-flush">           
    <div class="card-body py-8">
        <!--begin::Table container-->
        <div class="table-responsive">
            <!--begin::Table-->
            <table class="table table-custom align-middle gs-0 gy-4">
                <!--begin::Table head-->
                <thead>
                    <tr class="fw-bold text-gray-600" style="background-color: #1b1b1b">
                        <th class="ps-4 rounded-start" data-i18n="stats.map">Map</th>
                        <th class="text-nowrap" data-i18n="stats.loc">Location</th>
                        <th class="text-nowrap text-center" data-i18n="stats.type">Type</th>
                        <th class="text-nowrap text-center" data-i18n="stats.mode">Mode</th>
                        <th class="text-nowrap text-center" data-i18n="stats.score">Score</th>                                
                        <th class="text-nowrap rounded-end pe-4 min-w-75px" data-i18n="stats.date">Date</th>
                    </tr>
                </thead>
                <!--end::Table head-->

                <!--begin::Table body-->
                <tbody class="matches-list-body">
                    
                </tbody>
                <!--end::Table body-->
            </table>
            <!--end::Table-->
        </div>
        <!--end::Table container-->
    </div>            

    <div id="matches-list-loader" class="text-center">
        <div class="d-flex justify-content-center pt-10 pb-10">
            <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;">
                <span class="visually-hidden" data-i18n="example.loading">Loading...</span>
            </div>                                                       
        </div>
        <div class="pb-15 fw-semibold">
            <h3 class="text-gray-600 fs-5 mb-2" data-i18n="example.loading">Loading...</h3>
        </div>
    </div>
</div>
<!--end::FAQ card-->`;

const view = /*html*/`

    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <style>
            .top-rank:nth-of-type(1)::after, .top-rank:nth-of-type(2)::after, .top-rank:nth-of-type(3)::after {
                content: "";
                position: absolute;
                left: 0px;
                top: 0px;
                height: 100%;
                width: 100%;
                z-index: 0;                 
                border: 0;
                box-sizing: border-box;
                color: #fff;
                margin: 0;
                padding: 0;
            }
            .top-rank:nth-of-type(1)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 60.91%, rgba(52, 49, 43, 0.4) 77.74%, rgba(255, 193, 7, 0.4) 102.88%);
            }
            .top-rank:nth-of-type(2)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 58.44%, rgba(39, 50, 70, 0.4) 78.79%, rgba(71, 94, 138, 0.4) 100%);
            }
            .top-rank:nth-of-type(3)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.3) 61.73%, rgba(51, 43, 44, 0.3) 80.47%, rgba(119, 78, 55, 0.3) 100%);
            }

            .top-trophy-1{
                color: #ffc107;
            }
            .top-trophy-2{
                color: #C0C0C0;
            }
            .top-trophy-3{
                color: #CD7F32;
            }
            .table-custom
            {
                border-collapse: separate;
                border-spacing: 0 0.45rem;
            }
            
        </style>

        <div class="container-fluid px-0">
            <div class="card card-flush w-100 bgi-position-x-end bgi-position-y-center mb-6 px-20" style="height:246px;background-image:url('assets/media/misc/bg_players.png');">
                <div class="d-flex h-100 align-items-center">
                    <div class="card-title">
                        <h1 class="fs-2hx text-white teko-header" data-i18n="matches.title">Matches</h1>
                        <p class="text-gray-700 fs-6" data-i18n="matches.subtitle">All matches played in the platform!</p>
                    </div>
                </div>            
            </div>
            
            <div class="card card-flush shadow-none mb-4">
                <div class="card-header border-0 px-4">                    
                    <div class="card-title">
                    
                        <div class="d-flex align-items-center position-relative my-1 d-none">
                            <i class="ki-outline ki-magnifier fs-3 position-absolute ms-5"></i>
                            <input type="text" data-kt-customer-table-filter="search" class="form-control form-control-solid w-250px ps-12" placeholder="Search Customers">
                        </div>
                    
                        
                        <div class="d-flex align-items-center flex-wrap">                        
                            <div class="flex-shrink-0 me-2">
                                <ul class="nav" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <span class="nav-link btn btn-sm btn-color-muted btn-active-color-gray-200 btn-active-success active fw-semibold fs-7 px-4 me-1 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="true" role="tab">PUG</span>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <span class="nav-link btn btn-sm btn-color-muted btn-active-color-gray-200 btn-active-info fw-semibold fs-7 px-4 me-1 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="false" tabindex="-1" role="tab">Tournament</span>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <span class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light fw-semibold fs-7 px-4 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="false" tabindex="-1" role="tab">MM</span>
                                    </li>

                                    <li class="nav-item" role="presentation">
                                        <span class="nav-link btn btn-sm btn-color-muted btn-active-color-primary btn-active-light fw-semibold fs-7 px-4 text-uppercase" data-bs-toggle="tab" href="#" aria-selected="false" tabindex="-1" role="tab">Custom</span>
                                    </li>
                                </ul>
                            </div>
                            <!--end::Wrapper-->
                        </div>

                    </div>
                    <!--begin::Card title-->

                    <!--begin::Card toolbar-->
                    <div class="card-toolbar gap-2">
                        <!--begin::Toolbar-->
                        <div class="d-flex justify-content-end min-w-225px">
                            <select class="form-select form-select-sm form-select-solid" id="match-filter-map">
                            </select>
                        </div>
                        <div class="d-flex justify-content-end min-w-225px">
                            <select class="form-select form-select-sm form-select-solid" id="match-filter-location">
                            </select>
                        </div>
                        <!--end::Toolbar-->
                    </div>
                    <!--end::Card toolbar-->
                </div>
            </div>
            
            <div class="card card-flush bg-transparent">         
                <div class="table-responsive">
                    <table class="table table-custom align-middle gs-0 gy-4">
                        <thead>
                            <tr class="fw-bold text-gray-800 teko-semibold fs-4" style="background-color: #1b1b1b">
                                <th class="ps-4 rounded-start min-w-75px" data-i18n="stats.type">#</th>
                                <th class=""><span data-i18n="">Teams</span></th>
                                <th class="text-center"><span data-i18n="stats.score">Score</span></th>                                
                                <th class=" text-center" data-i18n="stats.loc">Location</th>
                                <th class=""><span data-i18n="">Vs</span></th>
                                <th class="text-center"><span data-i18n="stats.map">Map</span></th>
                                <th class=""><span data-i18n="">Anticheat</span></th>
                                <th class="pe-4 rounded-end text-center" data-i18n="stats.date">Date</th>                                                        
                            </tr>
                        </thead>

                        <tbody class="matches-list-body position-relative">
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="w-100 position-relative matches-loader">
            </div>
        </div>
    </div>
    <!--end::Container-->

`;


export default view;